import { collectTrackData } from '@/utils/Tracker/tracker';
import { collect } from '@/analytics';

const EVENTS = {
  NAME: 'gaEvent',
  CATEGORY: 'Onboarding',
  ACTIONS: {
    ACCESS_ONBOARDING: 'Acesso ao Onboarding',
    ACCESS_WORDPRESS_IA: 'Acesso fluxo WordPress com IA',
    ACCESS_WORDPRESS_DEFAULT: 'Acesso fluxo WordPress',
    ACCESS_SITEBUILDER: 'Acesso fluxo Criador de Sites',
    ACCESS_SITEBUILDER_V2: 'Clique no Botão - Quero este',
    ACCESS_SITEBUILDER_V2_BANNER: 'Clique no Botão - Quero este',
    ACCESS_OTHER_TOOLS: 'Acesso fluxo Outras Ferramentas',
    WORDPRESS_EDIT: 'WordPress - Editar',
    WORDPRESS_CANCEL: 'WordPress - Cancelar',
    WORDPRESS_GO_BACK_STEP_1: 'WordPress - Voltar Etapa 1',
    WORDPRESS_GO_FORWARD_STEP_1: 'WordPress - Avançar Etapa 1',
    WORDPRESS_USER: 'WordPress - Usuário',
    WORDPRESS_PASSWORD: 'WordPress - Senha',
    WORDPRESS_GO_BACK_STEP_2: 'WordPress - Voltar Etapa 2',
    WORDPRESS_GO_FORWARD_STEP_2: 'WordPress - Avançar Etapa 2',
    WORDPRESS_PORTAL_BUTTON: 'WordPress - Portal do Cliente',
    WORDPRESS_START_NOW: 'WordPress - Começar Agora',
    WORDPRESS_IA_EDIT_TEMPORARY_DOMAIN: 'WordPress com IA - Editar',
    WORDPRESS_IA_CANCEL_TEMPORARY_DOMAIN_EDIT: 'WordPress com IA - Cancelar',
    WORDPRESS_IA_GO_BACK_STEP_1: 'WordPress com IA - Voltar Etapa 1',
    WORDPRESS_IA_GO_FORWARD_STEP_1: 'WordPress com IA - Avançar Etapa 1',
    WORDPRESS_IA_USER_FIELD: 'WordPress com IA - Usuário',
    WORDPRESS_IA_PASSWORD_FIELD: 'WordPress com IA - Senha',
    WORDPRESS_IA_GO_BACK_STEP_2: 'WordPress com IA - Voltar Etapa 2',
    WORDPRESS_IA_GO_FORWARD_STEP_2: 'WordPress com IA - Avançar Etapa 2',
    WORDPRESS_IA_PORTAL_BUTTON: 'WordPress com IA - Portal do Cliente',
    WORDPRESS_IA_START_NOW: 'WordPress com IA - Começar agora',
    SITEBUILDER_GO_BACK_STEP_1: 'Criador de Sites - Voltar Etapa 1',
    SITEBUILDER_GO_FORWARD_STEP_1: 'Criador de Sites - Avançar Etapa 1',
    SITEBUILDER_PORTAL_BUTTON: 'Criador de Sites - Portal do Cliente',
    SITEBUILDER_START_NOW: 'Criador de Sites - Começar agora',
    OTHER_TOOLS_EDIT_TEMPORARY_DOMAIN: 'Outras Ferramentas - Editar',
    OTHER_TOOLS_CANCEL_TEMPORARY_DOMAIN_EDIT: 'Outras Ferramentas - Cancelar',
    OTHER_TOOLS_GO_BACK_STEP_1: 'Outras Ferramentas - Voltar Etapa 1',
    OTHER_TOOLS_GO_FORWARD_STEP_1: 'Outras Ferramentas - Avançar Etapa 1',
    OTHER_TOOLS_ACCESS_CPANEL: 'Outras Ferramentas - Acessar cPanel',
    OTHER_TOOLS_EXPLORE_SOFTACULOUS: 'Outras Ferramentas - Explorar Softaculous',
    OTHER_TOOLS_FTP_ACCESS_DATA: 'Outras Ferramentas - Dados de acesso FTP',
    OTHER_TOOLS_PORTAL_BUTTON: 'Outras Ferramentas - Portal do Cliente',
    OTHER_TOOLS_START_NOW: 'Outras Ferramentas - Começar agora',
  },
  LABELS: {
    CREATE_WORDPRESS_IA: 'Criar site WordPress com IA',
    CREATE_WORDPRESS_DEFAULT: 'Criar site WordPress',
    CREATE_SITEBUILDER: 'Criador de Sites',
    CREATE_SITEBUILDER_V2: 'Card Novo Criador de Site com IA',
    CREATE_SITEBUILDER_V2_BANNER: 'Onboarding - Novo Criador de Site com IA',
    CREATE_OTHER_TOOLS: 'Outras Ferramentas',
    EDIT_TEMPORARY_DOMAIN: 'Editar Domínio Temporário',
    CANCEL_TEMPORARY_DOMAIN_EDIT: 'Cancelar edição do domínio temporário',
    GO_BACK_STEP: 'Voltar para etapa anterior',
    GO_FORWARD_STEP: 'Avançar para próxima etapa',
    USER_FIELD: 'Preenchimento no campo usuário',
    PASSWORD_FIELD: 'Preenchimento do campo senha',
  },
};

const accessOnboarding = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_ONBOARDING,
    gaEventLabel: '',
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_ONBOARDING,
    label: '',
  });
};

const accessWordpressIA = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_WORDPRESS_IA,
    gaEventLabel: EVENTS.LABELS.CREATE_WORDPRESS_IA,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_WORDPRESS_IA,
    label: EVENTS.LABELS.CREATE_WORDPRESS_IA,
  });
};

const accessWordpressDefault = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_WORDPRESS_DEFAULT,
    gaEventLabel: EVENTS.LABELS.CREATE_WORDPRESS_DEFAULT,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_WORDPRESS_DEFAULT,
    label: EVENTS.LABELS.CREATE_WORDPRESS_DEFAULT,
  });
};

const accessSitebuilder = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_SITEBUILDER,
    gaEventLabel: EVENTS.LABELS.CREATE_SITEBUILDER,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_SITEBUILDER,
    gaEventLabel: EVENTS.LABELS.CREATE_SITEBUILDER,
  });
};

const accessSitebuilderV2 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_SITEBUILDER_V2,
    gaEventLabel: EVENTS.LABELS.CREATE_SITEBUILDER_V2,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_SITEBUILDER_V2,
    label: EVENTS.LABELS.CREATE_SITEBUILDER_V2,
  });
};

const accessSitebuilderV2Banner = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_SITEBUILDER_V2_BANNER,
    gaEventLabel: EVENTS.LABELS.CREATE_SITEBUILDER_V2_BANNER,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_SITEBUILDER_V2_BANNER,
    label: EVENTS.LABELS.CREATE_SITEBUILDER_V2_BANNER,
  });
};

const accessOtherTools = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.ACCESS_OTHER_TOOLS,
    gaEventLabel: EVENTS.LABELS.CREATE_OTHER_TOOLS,
  });
  collectTrackData({
    campaign: EVENTS.CATEGORY,
    action: EVENTS.ACTIONS.ACCESS_OTHER_TOOLS,
    label: EVENTS.LABELS.CREATE_OTHER_TOOLS,
  });
};

const wordpressEdit = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_EDIT,
    gaEventLabel: EVENTS.LABELS.EDIT_TEMPORARY_DOMAIN,
  });
};

const wordpressCancel = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_CANCEL,
    gaEventLabel: EVENTS.LABELS.CANCEL_TEMPORARY_DOMAIN_EDIT,
  });
};

const wordpressGoBackStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_GO_BACK_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const wordpressGoForwardStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_GO_FORWARD_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const wordpressUser = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_USER,
    gaEventLabel: EVENTS.LABELS.USER_FIELD,
  });
};

const wordpressPassword = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_PASSWORD,
    gaEventLabel: EVENTS.LABELS.PASSWORD_FIELD,
  });
};

const wordpressGoBackStep2 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_GO_BACK_STEP_2,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const wordpressGoForwardStep2 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_GO_FORWARD_STEP_2,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const wordpressPortalButton = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_PORTAL_BUTTON,
    gaEventLabel: '',
  });
};

const wordpressStartNow = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_START_NOW,
    gaEventLabel: '',
  });
};

const wordpressIaEditTempDomain = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_EDIT_TEMPORARY_DOMAIN,
    gaEventLabel: EVENTS.LABELS.EDIT_TEMPORARY_DOMAIN,
  });
};

const wordpressIaCancelTempDomainEdit = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_CANCEL_TEMPORARY_DOMAIN_EDIT,
    gaEventLabel: EVENTS.LABELS.CANCEL_TEMPORARY_DOMAIN_EDIT,
  });
};

const wordpressIaGoBackStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_GO_BACK_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const wordpressIaGoForwardStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_GO_FORWARD_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const wordpressIaUserField = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_USER_FIELD,
    gaEventLabel: EVENTS.LABELS.USER_FIELD,
  });
};

const wordpressIaPasswordField = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_PASSWORD_FIELD,
    gaEventLabel: EVENTS.LABELS.PASSWORD_FIELD,
  });
};

const wordpressIaGoBackStep2 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_GO_BACK_STEP_2,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const wordpressIaGoForwardStep2 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_GO_FORWARD_STEP_2,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const wordpressIaPortalButton = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_PORTAL_BUTTON,
    gaEventLabel: '',
  });
};

const wordpressIaStartNow = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.WORDPRESS_IA_START_NOW,
    gaEventLabel: '',
  });
};

const sitebuilderGoBackStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SITEBUILDER_GO_BACK_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const sitebuilderGoForwardStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SITEBUILDER_GO_FORWARD_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const sitebuilderPortalButton = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SITEBUILDER_PORTAL_BUTTON,
    gaEventLabel: '',
  });
};

const sitebuilderStartNow = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.SITEBUILDER_START_NOW,
    gaEventLabel: '',
  });
};

const otherToolsEditTempDomain = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_EDIT_TEMPORARY_DOMAIN,
    gaEventLabel: EVENTS.LABELS.EDIT_TEMPORARY_DOMAIN,
  });
};

const otherToolsCancelTempDomainEdit = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_CANCEL_TEMPORARY_DOMAIN_EDIT,
    gaEventLabel: EVENTS.LABELS.CANCEL_TEMPORARY_DOMAIN_EDIT,
  });
};

const otherToolsGoBackStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_GO_BACK_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_BACK_STEP,
  });
};

const otherToolsGoForwardStep1 = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_GO_FORWARD_STEP_1,
    gaEventLabel: EVENTS.LABELS.GO_FORWARD_STEP,
  });
};

const otherToolsAccessCpanel = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_ACCESS_CPANEL,
    gaEventLabel: '',
  });
};

const otherToolsExploreSoftaculous = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_EXPLORE_SOFTACULOUS,
    gaEventLabel: '',
  });
};

const otherToolsFtpAccessData = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_FTP_ACCESS_DATA,
    gaEventLabel: '',
  });
};

const otherToolsPortalButton = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_PORTAL_BUTTON,
    gaEventLabel: '',
  });
};

const otherToolsStartNow = () => {
  collect({
    event: EVENTS.NAME,
    gaEventCategory: EVENTS.CATEGORY,
    gaEventAction: EVENTS.ACTIONS.OTHER_TOOLS_START_NOW,
    gaEventLabel: '',
  });
};

const analytics = {
  initialStep: {
    accessOnboarding,
    accessWordpressIA,
    accessWordpressDefault,
    accessSitebuilder,
    accessSitebuilderV2,
    accessSitebuilderV2Banner,
    accessOtherTools,
  },
  wordpressIa: {
    editTempDomain: wordpressIaEditTempDomain,
    cancelTempDomain: wordpressIaCancelTempDomainEdit,
    goBackStep1: wordpressIaGoBackStep1,
    goForwardStep1: wordpressIaGoForwardStep1,
    user: wordpressIaUserField,
    password: wordpressIaPasswordField,
    goBackStep2: wordpressIaGoBackStep2,
    goForwardStep2: wordpressIaGoForwardStep2,
    portalButton: wordpressIaPortalButton,
    startNow: wordpressIaStartNow,
  },
  wordpressDefault: {
    editTempDomain: wordpressEdit,
    cancelTempDomain: wordpressCancel,
    goBackStep1: wordpressGoBackStep1,
    goForwardStep1: wordpressGoForwardStep1,
    user: wordpressUser,
    password: wordpressPassword,
    goBackStep2: wordpressGoBackStep2,
    goForwardStep2: wordpressGoForwardStep2,
    portalButton: wordpressPortalButton,
    startNow: wordpressStartNow,
  },
  sitebuilder: {
    goBackStep1: sitebuilderGoBackStep1,
    goForwardStep1: sitebuilderGoForwardStep1,
    portalButton: sitebuilderPortalButton,
    startNow: sitebuilderStartNow,
  },
  otherTools: {
    editTempDomain: otherToolsEditTempDomain,
    cancelTempDomain: otherToolsCancelTempDomainEdit,
    goBackStep1: otherToolsGoBackStep1,
    goForwardStep1: otherToolsGoForwardStep1,
    cpanelCta: otherToolsAccessCpanel,
    softaculousCta: otherToolsExploreSoftaculous,
    ftpCta: otherToolsFtpAccessData,
    portalButton: otherToolsPortalButton,
    startNow: otherToolsStartNow,
  },
};

export default analytics;
